import { rootActions } from "../reducers/root.slice";
import { call } from "typed-redux-saga";
import DatasetManager from "../lib/DatasetManager";
import { setStatus } from "../dom-utils";
import { processRows } from "./initialise.saga";

function* loadDatasetFromFile(
  action: ReturnType<typeof rootActions.loadDatasetFromFile>
) {
  const file = action.payload;

  try {
    setStatus(`Reading from file ${file.name}`);
    const rows = yield* call(DatasetManager.readFromFile, file);
    yield* call(processRows, rows, file.name);
  } catch (error) {
    setStatus(`Failed to read from file ${file.name}: ${error.message}`);
    console.error(error);
  }
}

export default loadDatasetFromFile;
